// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBCol, MDBIcon } from 'mdbreact';
import { connect } from 'react-redux';
import {
  toggleModal,
} from '../../storage/actions/modalsActions';
import sendClientInvite from '../../utils/api/post/sendClientInvite';
import { reloadData } from '../../storage/actions/applicationStateActions';
import DashboardIcon from '../dashboard/icons/DashboardIcon';

const UserManagementActions = ({
  toggleModal,
  item,
}) => {
  const handleOpenEdit = () => {
    toggleModal(true, 'addOrEditUsersForManagement', false, item);
  };

  const resendInvite = async () => {
    if (item.status === 'Accepted') return;
    toggleModal(true, 'loader');
    // Resend value if truthy indicates this is existing user. Otherwise new user will be created
    await sendClientInvite({ ...item, resend: 'resend' });

    toggleModal(false, 'loader');
  };

  const deleteUser = () => {
    const userInfo = {
      ...item,
      firstname: item.firstName,
      lastname: item.lastName,
      userType: item.role,
      number: item.phone,
    };

    toggleModal(true, 'deleteClientFromCompany', false, {
      client: userInfo,
    });
  };

  return (
    <div className="row-actions" >
        <button className="row-action-btn" type="button" title="Edit" onClick={handleOpenEdit}>
          <DashboardIcon name="edit" size={14} strokeWidth="2" />
        </button>
      <button className="row-action-btn row-action-btn--danger" type="button" title="Delete" onClick={deleteUser}>
        <DashboardIcon name="trash" size={14} strokeWidth="2" />
      </button>
      {item.status !== 'Accepted' ? (
        <button className="row-action-btn" type="button" title="Resend invitation" onClick={resendInvite}>
          <DashboardIcon name="flag" size={14} strokeWidth="2" />
        </button>
      ) : null}
    </div>
    
  );
};
const mapDispatchToProps = {
  toggleModal,
  reloadData,
};

export default connect(null, mapDispatchToProps)(UserManagementActions);
